@if (forecastVersion(); as version) {
  <div class="flex flex-col gap-4">
    @if (version === undefined || version.progress === 0) {
      <mat-progress-bar mode="indeterminate" />
    } @else {
      <mat-progress-bar mode="determinate" [value]="version.progress * 100" />
    }
    <div class="flex flex-row justify-center items-center">
      <pm-icon [icon]="GaugeIcon" class="mr-1"></pm-icon>
      @if (version === undefined) {
        <p>{{ 'UTILITY.CALCULATING_VERSION' | translate }}...</p>
      } @else {
        <p>
          <!-- 5 since it would happen otherwise quite often that 1 second remaining is displayed and it takes more than 1 second acutally -->
          @if (version.progress < 0.94 || version.progress === 0) {
            {{ 'RESULT.LOADING.TIME' | translate }}
            @if (version.estimatedDuration === 0) {
              {{ 'UTILITY.IS_BEING_CALCULATED' | translate }}...
            } @else {
              {{ this.timeText(version.estimatedDuration) }}
            }
          } @else {
            {{ 'UTILITY.FINISHING_VERSION' | translate }}...
          }
        </p>
      }
    </div>
  </div>
}
